//Infrastructure / Supabase adapter
import { supabase } from '../../../infra_/supabase/supabaseClient.js'

export const InventarioVentaRepository = {
  async listarTotales(filtros = {}) {
    let query = supabase
      .from("vista_inventario_salidas_totales")
      .select("*")
      .order("fecha", { ascending: false })
      .order("cantidad", { ascending: false } )
      .limit(100);
   

    if (filtros.desde) {
      query = query.gte("fecha", filtros.desde);
    }

    const { data, error } = await query;
    if (error) throw error;

    return data;
  },
};